import { getEndpoint } from "../endpoints";

import {
	httpServiceInstance,
	type HttpService,
} from "./http.service";

export class DatasetFormulaeService {
	private static readonly instance: DatasetFormulaeService;
	private static http: HttpService;
	private static endpoint: string;
	private static base_url: string;

	constructor() {
		DatasetFormulaeService.http = httpServiceInstance;
		DatasetFormulaeService.endpoint = getEndpoint();
		DatasetFormulaeService.base_url = `${DatasetFormulaeService.endpoint}/api/dataset/admin/formulae`;
	}

	async getDatasetFormulaeMetadata(): Promise<any> {
		const url = `${DatasetFormulaeService.base_url}/metadata`;
		const { data } =
			await DatasetFormulaeService.http.get<any>(url);
		return data;
	}

	async getAllFormulae(filterBody: any): Promise<any> {
		const url = `${DatasetFormulaeService.base_url}/all`;
		const { data } =
			await DatasetFormulaeService.http.post<any>(url, {
				data: filterBody,
			});
		return data;
	}

	async createFormulae(formulaData: any): Promise<any> {
		const url = `${DatasetFormulaeService.base_url}/add`;
		const { data } =
			await DatasetFormulaeService.http.post<any>(url, {
				data: formulaData,
			});
		return data;
	}

	async updateFormulae(
		formulaeId: string,
		formulaData: any
	): Promise<any> {
		const url = `${DatasetFormulaeService.base_url}/${formulaeId}/update`;
		const { data } =
			await DatasetFormulaeService.http.post<any>(url, {
				data: formulaData,
			});
		return data;
	}

	async deleteFormulae(formulaId: string): Promise<any> {
		const url = `${DatasetFormulaeService.base_url}/${formulaId}/delete`;
		const { data } =
			await DatasetFormulaeService.http.get<any>(url);
		return data;
	}
}
